export default __webpack_public_path__ + "static/media/47t.64d42211.jpg";